<template>
  <div class="mobile-nav">
    <div
      id="mobile-navbar"
      class="position-fixed bg-secondary h-100 bg-contain bg-no-repeat bg-left-bottom"
      :class="{ 'open-mobile-menu': mobileMenuSwitch }"
      :style="{backgroundImage: `url(${require('@/assets/images/planters.png')})`}"
    >
      <div class="user-meta w-100 bg-primary">
        <button class="btn" @click="toggleMobileMenu(false)">
          <close-icon fillColor="#ffffff" />
        </button>
        <b-container class="h-100">
          <b-row class="h-100 justify-content-between ml-1">
            <b-col class="d-flex align-items-center">
              <router-link to="/profile">
                <h4 class="pt-5 pb-2">
                  <span class="text-white-50">Hi,</span>
                  <span class="text-white ml-2">{{ userObj.firstname }}</span
                  >ß
                </h4>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
      </div>

      <div class="mt-0">
        <ul class="list-unstyled">
          <li v-for="menu in menuLinks" :key="menu.name">
            <b-button :to="menu.link" class="w-100 text-left py-3">
              <i :class="menu.icon"></i>
              {{ menu.name }}
              <b-badge class="ml-2 mr-2" variant="warning" v-if="menu.new">New</b-badge>
            </b-button>
          </li>
          <li>
          <b-button class="w-100 text-left py-3" @click="openSupport()">
            <i class="fa fa-headset"></i>
            Support
          </b-button>
        </li>
          <li>
            <b-button class="w-100 text-left py-3" @click="logout">
              <i class="ti-power-off"></i>
              Log Out
            </b-button>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="mobile-menu-overlay w-100 h-100 position-fixed"
      :class="{ 'show-mobile-menu-oberlay': mobileMenuSwitch }"
      style="top:0;left:0;z-index:1035"
      @click="toggleMobileMenu(false)"
    ></div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "mobile-navbar",
  data() {
    return {
      menuLinks: [
        { name: "Dashboard", link: "/dashboard", icon: "fa fa-home" },
        { name: "Farm Funding", link: "/farms/funding", icon: "fa fa-chart-line" },
        { name: "Farm Ownership", link: "/farms/ownership", icon: "fa fa-map"},
        { name: "Farm For Me", link: "/farms", icon: "fa fa-seedling"},
        { name: "Edibles", link: "/edibles", icon: "fas fa-luggage-cart", new: true  },
        { name: "Wallet", link: "/wallet", icon: "fa fa-credit-card" },
        //{ name: "Sales", link: "/sales", icon: "fa fa-shopping-basket" },
        //{ name: "Rentals", link: "/rentals", icon: "fa fa-scissors" },
        { name: "Referrals", link: "/referrals", icon: "fa fa-sitemap" },
        { name: "Manage Profile", link: "/profile", icon: "fa fa-drivers-license" }
      ]
    };
  },
  computed: {
    ...mapState("ui", ["mobileMenuSwitch"]),
    ...mapState(["userObj"]),
    setMenu() {
      return [
        { name: "Dashboard", link: "/dashboard", icon: "fa fa-home" },
        { name: "Farm Funding", link: "/farms/funding", icon: "fa fa-chart-line" },
        { name: "Farm Ownership", link: "/farms/ownership", icon: "fa fa-map"},
        { name: "Farm For Me", link: "/farms", icon: "fa fa-seedling"},
        { name: "Edibles", link: "/edibles", icon: "fas fa-luggage-cart", new: true  },
        { name: "Wallet", link: "/wallet", icon: "fa fa-credit-card" },
        //{ name: "Sales", link: "/sales", icon: "fa fa-shopping-basket" },
        //{ name: "Rentals", link: "/rentals", icon: "fa fa-scissors" },
        { name: "Referrals", link: "/referrals", icon: "fa fa-sitemap" },
        { name: "Manage Profile", link: "/profile", icon: "fa fa-drivers-license" }
      ];
    }
  },
  methods: {
    ...mapActions("ui", ["toggleMobileMenu"]),
    ...mapActions("auth", ["logout"]),
    openSupport() {
      try {
        this.$drift.openSideBar();
      } catch (error) {
        //console.log(error);

        return;
      }
    }
  },
  mounted() {
    this.$drift.hide();
  }
};
</script>

<style lang="scss">
.menu-item {
  font-size: 1em;
  font-weight: 500;
}
#mobile-navbar {
  transition: all 0.3s ease;
  left: -300px;
  width: 250px;
  z-index: 1040;
  top: 0;
  //   left: 0;
  overflow-y: auto;

  .nav-link {
    color: var(--primary);
  }

  .router-link-active {
    color: var(--primary);
  }
}

.open-mobile-menu {
  left: 0 !important;
}

.mobile-menu-overlay {
  transition: all 0.3s ease;
  display: none;
  opacity: 0;

  background-color: rgba($color: #000000, $alpha: 0.6);
}

.show-mobile-menu-oberlay {
  display: block;
  opacity: 1;
}
</style>
